import { motion } from 'framer-motion';
import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'このサービスは医療行為ですか？',
      answer: 'いいえ、本サービスは医療行為・診断・治療を行うものではありません。健康情報の提供を目的としたサービスです。体調不良や不安がある場合は、必ず医師・医療機関にご相談ください。',
    },
    {
      question: '個人情報は取得されますか？',
      answer: '氏名・住所・生年月日などの個人を特定する情報は取得しません。入力されたデータは計算にのみ使用され、匿名で処理されます。',
    },
    {
      question: 'どのような血液データが必要ですか？',
      answer: 'AST（GOT）、ALT（GPT）、血小板数の3つの項目が必要です。これらは一般的な健康診断や血液検査の結果に記載されています。',
    },
    {
      question: '結果はどのように解釈すればよいですか？',
      answer: '結果は国際指標に基づくリスクグループの分類として表示されます。これは診断ではなく、参考情報としてご活用ください。詳しい解釈や対応については、医師にご相談されることをお勧めします。',
    },
    {
      question: '料金はかかりますか？',
      answer: '現在、基本的なチェック機能は無料でご利用いただけます。将来的には、過去データ保存や経時変化グラフなどの追加機能を有料で提供する予定です。',
    },
    {
      question: 'スマートフォンでも利用できますか？',
      answer: 'はい、スマートフォン、タブレット、パソコンなど、あらゆるデバイスでご利用いただけます。',
    },
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">よくある質問</h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            サービスに関するよくある質問をまとめました
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="bg-white border-2 border-gray-200 rounded-xl overflow-hidden hover:border-blue-300 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="text-base font-bold text-gray-900 pr-4">{faq.question}</span>
                <div className="flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-gray-600 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 p-6 bg-blue-50 rounded-xl border border-blue-200 text-center"
        >
          <p className="text-sm text-gray-700 mb-4">その他のご質問がある場合は、お気軽にお問い合わせください</p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;